// ANCHOR Model
import createModel from '@lxsmnsyc/react-scoped-model';

// ANCHOR Results
import { ICourseResult, ApprovalStatus } from '@lyon/utils/api/results/course';

interface IProps {
  data?: ICourseResult;
  fromProvider?: boolean;
  hasAvatar?: boolean;
  myCourse?: boolean;
  approvalStatus?: ApprovalStatus;
}

export const CourseCardData = createModel<IProps, IProps>((props) => props, {
  displayName: 'Models.CourseCardData',
});
